// extracted by mini-css-extract-plugin
export default {"productWrapper":"nJdZNH","imageContainer":"RTkNX4","active":"us1Iz8","productImage":"VfxNLb","iconContainer":"LV7LPh","fadeIn":"p9wCs9","checkmark":"PkNLnC"};